module.exports = __webpack_public_path__ + "assets/img/headPortrait1.055bee30.png";